export const biteCreatedcontinueBtnDataSet = { cy: 'BiteCreated-continue-btn' };
export const nameLabel = { cy: 'name-label' };
export const nameInputDataSet = { cy: 'name-input' };
export const nameInputAcceptDataSet = { cy: 'name-input-accept' };
